export enum CheckboxSize {
    LARGE = 'large',
    MEDIUM = 'medium',
    SMALL = 'small',
}
